import type { HostConfiguration, HostOptions } from './contracts';
export { createHostCapabilities } from './config/capabilities';
const ATTACHMENT_POLICY = Object.freeze({
  maxCount: 10, maxSizeBytes: 20 * 1024 * 1024,
  extensions: ['.pdf', '.docx', '.xlsx', '.csv', '.txt', '.md', '.png', '.jpg', '.jpeg', '.webp'],
  mimeTypes: ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv', 'text/markdown',
    'text/plain', 'image/png', 'image/jpeg', 'image/webp'],
});
const SOURCE_POLLING = Object.freeze({ intervalMs: 1500, maxAttempts: 80 });
const fields = (value: { [key: string]: string | undefined }) => Object.fromEntries(Object.entries(value).filter(([, item]) => item !== undefined && item !== ''));
export const hostConfiguration = (options: HostOptions): HostConfiguration => ({
  requestOptions: { baseUrl: String(options.apiBaseUrl ?? '').trim(), token: options.apiToken, fetchImpl: options.fetchImpl },
  scope: fields({ projectId: options.projectId, userId: options.userId }),
  sessionDefaults: fields({ project_id: options.projectId, user_id: options.userId,
    instance_id: options.instanceId, domain_pack_domain: options.domainPackDomain,
    domain_pack_version: options.domainPackVersion, function_type: options.functionType }),
  listDefaults: { status: 'active', page: 1, page_size: 20, include_context: false },
  sourceDefaults: fields({ project_id: options.projectId, user_id: options.userId }),
  streamDefaults: fields({ instanceId: options.instanceId, domainPackVersion: options.domainPackVersion }),
  controller: { attachmentPolicy: options.attachmentPolicy ?? ATTACHMENT_POLICY, sourcePolling: options.sourcePolling ?? SOURCE_POLLING },
});
